/* eslint-disable no-extra-boolean-cast */ // no idea why it needed to cast it back to its original boolean. No test around this not going to be bothered to fix the lint
/* eslint-disable react/jsx-tag-spacing */
/* eslint-disable object-curly-spacing */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable operator-linebreak */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-one-expression-per-line */
import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {
    quoteFormSelector,
    availableProductResultsSelector,
    hasProductsWithExcessHigherThanFilterValue,
    resultsConfigSelector
} from 'ctm-selectors';
import {getHasSavedResults} from 'ctm-selectors/selectors/results';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faInfoCircle} from '@fortawesome/pro-regular-svg-icons';
import {ModalButton, SimpleFlexbox} from 'ctm-components';
import { pageContext } from 'ctm-util-functions';
import { experimentIDEnum } from 'ctm-vertical-base/base/reducers/page';
import {vehicleMake} from '../../../core/state_selectors';
import styles from './welcome_message.css';
import {UpdateQuoteModal} from './update_quote_dialog';
import { StartANewQuoteModal } from './start_a_new_quote_dialog';

/**
 * WelcomeMessage displays Results welcome message with Icon child and available results count
 * @param {Boolean} excessFilterValue - the value of the results filter excess value
 * @param {Boolean} hideHighExcess - determines if results items with a higher excess than excessFilterValue are displayed
 * @returns {Node|null} The welcome message component or null depending on the visibility rule
 */

class _WelcomeMessage extends PureComponent {

    onClick = () => {
        const {dispatch, hideHighExcess} = this.props;
        const hide = !hideHighExcess;
        dispatch({
            type: 'SET_PAGE_VALUE',
            identifier: 'isHideHighExcess',
            value: hide
        });
    };

    renderDisclaimer = (showFeaturesDisclaimer) => (
        <div className={styles.gstMessage}>
            Prices quoted may change based on factors like rounding and further questions asked by the insurer. Results
            are inclusive of GST & Govt. charges.
            {showFeaturesDisclaimer && (
                <div className={styles.gstMessage_extended}>
                    <p>
                        <strong>The information on this page is subject to exclusions, restrictions, and sub-limits.
                            Please refer to the PDS for details.</strong>
                    </p>
                </div>
            )}
        </div>
    );

    renderHigherExcess = (excessFilterValue, hideHighExcess, hasHighExcess) => (
        <>
            {hasHighExcess && (
                <div className={styles.higherExcess}>
                    <div className={styles.higherExcessWrapper}>
                        <strong>
                            Your excess amount is set to $
                            {excessFilterValue}
                        </strong>
                        {!hideHighExcess &&
                            <p>We may also show you products that have a higher excess, to provide you with a larger
                                selection of competitive products.</p>}
                    </div>
                    <div className={`${!hideHighExcess ? styles.higherExcessBtnWrapper : ''}`}>
                        {!hideHighExcess && (
                            <button type="button" className={styles.higherExcessBtn} onClick={this.onClick}>
                                Hide products with an excess higher than $
                                {excessFilterValue}
                            </button>
                        )}
                        {hideHighExcess && (
                            <button type="button" className={styles.higherExcessBtn} onClick={this.onClick}>
                                Return to all products
                            </button>
                        )}
                    </div>
                </div>
            )}
        </>
    );

    handleQuoteModal = (isOpen, previousExcessValue, previousCoverType, hasActiveFilter) => {
        const {dispatch} = this.props;
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'helpers.updateQuoteModal',
            value: {open: isOpen}
        });

        if (!isOpen && hasActiveFilter) {
            // display Cancel Changes label so user know they haven't completed their edits
            dispatch({
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'filters.showFiltersUpdateButton',
                value: true
            });
            // reset results config filter values
            dispatch({
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'filters.requestedExcess',
                value: previousExcessValue
            });
            dispatch({
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'filters.coverType',
                value: previousCoverType
            });
            // reset cover detail values
            dispatch({
                type: 'SET_VALUE',
                identifier: 'coverDetail.requestedExcess',
                stateKey: 'vertical.quote',
                value: previousExcessValue
            });
            dispatch({
                type: 'SET_VALUE',
                identifier: 'coverDetail.coverType',
                stateKey: 'vertical.quote',
                value: previousCoverType
            });
            // add filter actions to results config filters currentFilterActions
            dispatch({
                type: 'SET_FILTER_ACTION',
                resultsStateKey: 'filters.requestedExcess',
                resultsStagedStateKey: 'helpers.filters.requestedExcess',
                formStateKey: 'coverDetail.requestedExcess'
            });
            dispatch({
                type: 'SET_FILTER_ACTION',
                resultsStateKey: 'filters.coverType',
                resultsStagedStateKey: 'helpers.filters.coverType',
                formStateKey: 'coverDetail.coverType'
            });
        }
    };

    handleStartANewQuoteModal = (isOpen, previousExcessValue, previousCoverType, hasActiveFilter) => {
        const {dispatch} = this.props;
        dispatch({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'helpers.startANewQuoteModal',
            value: {open: isOpen}
        });

        if (!isOpen && hasActiveFilter) {
            // display Cancel Changes label so user know they haven't completed their edits
            dispatch({
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'filters.showFiltersUpdateButton',
                value: true
            });
            // reset results config filter values
            dispatch({
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'filters.requestedExcess',
                value: previousExcessValue
            });
            dispatch({
                type: 'SET_RESULTS_CONFIG_VALUE',
                key: 'filters.coverType',
                value: previousCoverType
            });
            // reset cover detail values
            dispatch({
                type: 'SET_VALUE',
                identifier: 'coverDetail.requestedExcess',
                stateKey: 'vertical.quote',
                value: previousExcessValue
            });
            dispatch({
                type: 'SET_VALUE',
                identifier: 'coverDetail.coverType',
                stateKey: 'vertical.quote',
                value: previousCoverType
            });
            // add filter actions to results config filters currentFilterActions
            dispatch({
                type: 'SET_FILTER_ACTION',
                resultsStateKey: 'filters.requestedExcess',
                resultsStagedStateKey: 'helpers.filters.requestedExcess',
                formStateKey: 'coverDetail.requestedExcess'
            });
            dispatch({
                type: 'SET_FILTER_ACTION',
                resultsStateKey: 'filters.coverType',
                resultsStagedStateKey: 'helpers.filters.coverType',
                formStateKey: 'coverDetail.coverType'
            });
        }
    };

    renderUpdateQuotesModal = () => {
        const contentProps = {
            label: 'Update Quotes'
        };

        const elementProps = {
            'data-id': 'savedResults.ModalDialog.updateQuotes',
            href: 'javascript:;',
            tagName: 'a',
            id: 'savedResults.ModalDialog.updateQuotes'
        };
        return <ModalButton contentProps={contentProps} elementProps={elementProps} onClickFunction={() => {
            this.handleQuoteModal(true);
        }}/>;
    };

    renderStartANewQuoteModal = () => {
        const contentProps = {
            label: 'Start a new quote'
        };

        const elementProps = {
            'data-id': 'savedResults.ModalDialog.startANewQuote',
            href: 'javascript:;',
            tagName: 'a',
            id: 'savedResults.ModalDialog.startANewQuote'
        };
        return <ModalButton contentProps={contentProps} elementProps={elementProps} onClickFunction={() => {
            this.handleStartANewQuoteModal(true);
        }}/>;
    };

    renderSavedResultsMessage = () => {
        const hasSavedResults = getHasSavedResults();
        const isXs = pageContext.getProps().pageState.breakpoint === 'xs';
        return (
            <>
                {hasSavedResults && (
                    <div className={styles.savedResultsContainer}>
                        <div className={styles.savedResultsExcessWrapper}>
                            <FontAwesomeIcon icon={faInfoCircle} className={styles.info_icon}/>
                            <p>
                                The quotes and product information were accurate at the time you originally quoted and
                                are subject to change.
                                You should consider whether the product is suitable for you and read the PDS before
                                purchasing.
                            </p>
                        </div>
                        <div className={styles.savedResultsBtnRow} style={{ width: isXs ? '30rem' : '32rem' }}>
                            <div className={styles.startANewQuoteBtnWrapper}>
                                {this.renderStartANewQuoteModal()}
                            </div>
                            <div className={styles.savedResultsBtnWrapper}>
                                {this.renderUpdateQuotesModal()}
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };

    /**
     * @returns {Node|null} returns the children or null depending on the visibility rule
     */
    render = () => {
        const {
            make,
            availableCount = 0,
            isCTMPage,
            excessFilterValue,
            hideHighExcess,
            hasHighExcess,
            showFeaturesDisclaimer,
            hasSavedResults,
            previousExcessValue,
            previousCoverType,
            hasActiveFilter
        } = this.props;
        if (!availableCount) {
            return null;
        }

        const {experimentID} = this.props;
        const xxlValue = experimentID === experimentIDEnum.CTM_REBRAND ? 10 : 12;

        return (
            <SimpleFlexbox
                column="xs"
                row="sm"
                contentBetween="xs"
                itemsCenter="xs"
                display="flex"
                md={9}
                lg={9}
                xl={10}
                xxl={xxlValue}
                margin={['top', 'bottom_xsmall']}
            >
                <SimpleFlexbox display="block" contentBetween="xs" itemsCenter="xs">
                    <div className={styles.message}>
                        <span data-id="results-title">
                            {hasSavedResults ? (
                                <>Here are the </>
                            ) : (
                                <>We found </>
                            )}
                            <strong>
                                {availableCount}
                                {hasSavedResults ? <> saved quotes</> : <> results</>}
                            </strong>
                            {' for your '}
                            {hasSavedResults ? <strong>{make.toUpperCase()}</strong> : make.toUpperCase()}
                        </span>
                        {this.renderDisclaimer(showFeaturesDisclaimer)}
                        {isCTMPage && (
                            <>
                                {hasSavedResults ? (
                                    this.renderSavedResultsMessage()
                                ) : (
                                    (!hasSavedResults) && (
                                        this.renderHigherExcess(excessFilterValue, hideHighExcess, hasHighExcess)
                                    )
                                )}
                            </>
                        )}
                        <UpdateQuoteModal closeModal={() => {
                            this.handleQuoteModal(false, previousExcessValue, previousCoverType, hasActiveFilter);
                        }}/>
                        <StartANewQuoteModal closeModal={() => {
                            this.handleStartANewQuoteModal(false, previousExcessValue, previousCoverType, hasActiveFilter);
                        }}/>
                    </div>
                </SimpleFlexbox>
            </SimpleFlexbox>
        );
    };

}

_WelcomeMessage.propTypes = {
    make: PropTypes.string.isRequired,
    availableCount: PropTypes.number,
    excessFilterValue: PropTypes.string,
    isCTMPage: PropTypes.bool,
    hideHighExcess: PropTypes.bool,
    hasHighExcess: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
    showFeaturesDisclaimer: PropTypes.bool,
    hasSavedResults: PropTypes.bool,
    previousExcessValue: PropTypes.string,
    previousCoverType: PropTypes.string,
    hasActiveFilter: PropTypes.bool,
    experimentID: PropTypes.string
};

const mapStateToProps = (state) => {
    const brandCode = state.getIn(['page', 'brand']);
    const resultsConfig = resultsConfigSelector(state);
    const form = quoteFormSelector(state);
    const excessFilterValue = form.getIn(['coverDetail', 'requestedExcess']);
    // CTM Pages are any brands using the core CTM schmea
    const isCTMPage = brandCode !== 'choo';
    const hideHighExcess = isCTMPage && state.getIn(['page', 'isHideHighExcess']);
    const displayMode = resultsConfig.get('displayMode');
    const showFeaturesDisclaimer = displayMode === 'column';
    let previousExcessValue = form.getIn(['helpers', 'prefill', 'previousExcessValue']);
    previousExcessValue = !!previousExcessValue ? previousExcessValue.toString() : excessFilterValue.toString();
    const coverType = form.getIn(['coverDetail', 'coverType']);
    let previousCoverType = form.getIn(['helpers', 'prefill', 'previousCoverType']);
    previousCoverType = !!previousCoverType ? previousCoverType : coverType;
    let hasActiveFilter = form.getIn(['helpers', 'prefill', 'isResultsFilterActive']);
    hasActiveFilter = !!hasActiveFilter ? hasActiveFilter : false;
    const serverConfigEnv = state.getIn(['serverConfig', 'env']);
    const experimentID = state.getIn(['page', 'experimentId']);
    return {
        availableCount: availableProductResultsSelector(state, excessFilterValue),
        hasHighExcess: hasProductsWithExcessHigherThanFilterValue(state, excessFilterValue),
        make: vehicleMake({state}),
        isCTMPage,
        excessFilterValue,
        hideHighExcess,
        showFeaturesDisclaimer,
        hasSavedResults: getHasSavedResults(),
        previousExcessValue,
        previousCoverType,
        hasActiveFilter,
        serverConfigEnv,
        experimentID
    };
};

const WelcomeMessage = connect(mapStateToProps)(_WelcomeMessage);

export {_WelcomeMessage, WelcomeMessage};
